import * as React from "react";
import { Box, Typography } from "@material-ui/core";
import InboxIcon from "@material-ui/icons/Inbox";
import { useTranslation } from "react-i18next";

export interface EmptyProps {
  isBorder?: boolean;
  description?: string;
}

export default function EmptyComponent({isBorder = true, description}: EmptyProps) {
  const {t} = useTranslation();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{
        border: isBorder ? "1px solid #e9dede" : "none",
        borderRadius: 8,
        padding: "20px",
        color: "#bfbfbf",
        backgroundColor: "#fafafa",
      }}
    >
      <InboxIcon style={{fontSize: 48, color: "#d9d9d9"}} />
      <Typography variant="body2" style={{marginTop: 8, color: "#8c8c8c"}}>
        {description || t("nodata")}
      </Typography>
    </Box>
  );
}
